const colors = {
  primary: "#ff6600",
  white: "#ffffff",
  light: " #f2f2f2",
};

export default colors;
